import React, { Component } from "react"
import { connect } from 'react-redux'
import {Storage,MessageText} from '../../configs'
import { msg } from "../Notifications/MsgBox"
import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction"
import { Select} from "../core";

class RejectWithOptionModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
            comment: "",
            rejectOption : "",
        }
       
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        const text = target.text;

        this.setState({
            [name]: value
        })
        
    }
    

   async handleReject(event)
    {
        await this.props.startLoading()
        const user=Storage.getUser()
        const {rejectOption,comment}= this.state
      
        console.log("reject save");
        console.log("Reject_Result: " + this.state.comment);
        console.log("Reject_By: " + user.userName);

        if (rejectOption !== "") {
            window.$('#RejectWithOptionModal').modal('hide');
            let valueRejectOption = rejectOption.split("|")
            this.props.onHandleReject(this,event,this.state.comment+"", user.userName,valueRejectOption[0],valueRejectOption[1]);
        }
        else if (this.state.rejectOption === "") {
            msg.error(`กรุณาระบุเหตุผลส่งกลับแก้ไข`)
            this.props.stopLoading()
            return
        }
        // else {
        //     msg.error(`กรุณาระบุคำอธิบายส่งกลับแก้ไข`)
        //     this.props.stopLoading()
        //     return
        // }   

    }

    getRejectOption (){

        let data = this.props.RejectDataOption.sort(function(a, b){return a.sotrt-b.sotrt});;
        return data;
    }

    render() {
        const {rejectOption} = this.state
        console.log ("RejectDataOption   => ",this.props.RejectDataOption)
        console.log("RejectWithOptionModal.render()")
        return (
            <div className="modal fade sp-modal rrs-modal" id="RejectWithOptionModal" tabIndex={-1} role="dialog" aria-labelledby="RejectWithOptionModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header bg">
                            <h5 className="modal-title" id="RejectWithOptionModalLabel">Reject</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body rrs-container">

                            <div className="rrs-detail3">
                           
                                <div className="row">
                                <div className="rrs-form col-12" >
                                        <div className="row">
                                        <div className="col-2">
                                        <label htmlFor="a3" className="rrs-label"><span className="required">*</span> เหตุผล</label>
                                        </div>
                                        <div className="rrs-detail-data col-10">
                                        <Select
                                                        name="rejectOption"
                                                        value={rejectOption}
                                                        onChange={this.handleChange}
                                                    >
                                                        <option value="">-- select --</option>
                                                        {this.props.RejectDataOption && this.getRejectOption().map((reject, index) => (
                                                        (
                                                            <option
                                                                key={index}
                                                                value={reject.value + '|' + reject.display}
                                                                text={reject.value}>
                                                                {reject.display}
                                                            </option>
                                                        )
                                                        ))}
                                                    </Select>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div className="row">
                                    <div className="rrs-form col-12" >
                                        <div className="row">
                                        <div className="col-2">
                                        <label htmlFor="a3" className="rrs-label"> คำอธิบาย</label>
                                        </div>
                                        <div className="rrs-detail-data col-10">
                                        <textarea cols="100" rows="50" maxLength="1000" className="form-control rrs-textarea" name="comment" onChange={this.handleChange}></textarea>
                                        </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mx-0 header-button-row">
                                    <div className="col-12 sp-header-button-panel2">
                                        <a  className="sp-btn-icon sp-btn-gray" onClick={(event) => { this.handleReject(event) }}>
                                            <i className="icon btn-order-check-green" />
                                            <span className="sp-btn-icon-label3">{MessageText.APP.MSG_BOX_BUTTON_TEXT_YES}</span>
                                        </a>
                                        <a href="#" className="sp-btn-icon sp-btn-gray" data-dismiss="modal" aria-label="Close">
                                            <i className="icon btn-cancel" />
                                            <span className="sp-btn-icon-label2">{MessageText.APP.MSG_BOX_BUTTON_TEXT_NO}</span>
                                        </a>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
      
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
        startLoading: () => dispatch(startLoadingAction()),
        stopLoading: () => dispatch(stopLoadingAction()),
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(RejectWithOptionModal)